import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatCheckboxModule} from '@angular/material/checkbox';

import { CheckPermissionsDirective } from './directives/check-permission.directive';
import { TimeOffInfoComponent } from './components/time-off-info/time-off-info.component';
import { MessageComponent } from './components/message/message.component';
import { ShiftTimingDisplayPipe } from './pipes/shift-timing-display.pipe';

const modules: any = [
  CommonModule,
  MatButtonModule,
  MatBadgeModule,
  MatToolbarModule,
  MatProgressBarModule,
  MatFormFieldModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatSnackBarModule,
  MatExpansionModule,
  MatAutocompleteModule,
  MatIconModule,
  MatTableModule,
  MatDividerModule,
  MatDialogModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatSelectModule,
  MatCardModule,
  MatMenuModule,
  MatTabsModule,
  MatTooltipModule,
  MatCheckboxModule
]

@NgModule({
  declarations: [
    CheckPermissionsDirective,
    TimeOffInfoComponent,
    MessageComponent,
    ShiftTimingDisplayPipe
  ],
  imports: [...modules, ReactiveFormsModule],
  exports: [
    ...modules,
    MessageComponent,
    CheckPermissionsDirective,
    ShiftTimingDisplayPipe
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} }
  ]
})
export class SharedModule { }
